module.exports = __webpack_public_path__ + "img/airflow.ec7f9164.svg";